import { render } from "./mMTBResult.vue?vue&type=template&id=ea118350&scoped=true"
import script from "./mMTBResult.vue?vue&type=script&lang=js"
export * from "./mMTBResult.vue?vue&type=script&lang=js"

import "./mMTBResult.vue?vue&type=style&index=0&id=ea118350&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea118350"]])

export default __exports__